/**
 * Cliente WebSocket reconectável com backoff exponencial.
 * Uso:
 *   const ws = createWsClient("/api/ws/executions", (msg) => handle(msg));
 *   ws.close(); // para desconectar
 */

export interface WsClient {
  close: () => void;
}

export function createWsClient(
  path: string,
  onMessage: (data: unknown) => void,
  onOpen?: () => void,
): WsClient {
  let socket: WebSocket | null = null;
  let stopped = false;
  let retries = 0;

  function connect() {
    if (stopped) return;
    const protocol = location.protocol === "https:" ? "wss:" : "ws:";
    const url = `${protocol}//${location.host}${path}`;
    socket = new WebSocket(url);

    socket.onopen = () => {
      retries = 0;
      onOpen?.();
    };

    socket.onmessage = (ev) => {
      try {
        const data = JSON.parse(ev.data as string);
        if (data?.type === "ping") return; // keep-alive
        onMessage(data);
      } catch {
        // ignore malformed
      }
    };

    socket.onclose = () => {
      if (stopped) return;
      const delay = Math.min(1000 * 2 ** retries, 30_000);
      retries++;
      setTimeout(connect, delay);
    };

    socket.onerror = () => {
      socket?.close();
    };
  }

  connect();

  return {
    close() {
      stopped = true;
      socket?.close();
    },
  };
}
